





















































import Vue from 'vue'

export default Vue.extend({
  props: {
    halls:
    {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      currentIndex: 0
    }
  },
  computed: {
    CurrentIndex (): number {
      return this.currentIndex
    }
  },
  methods: {
    goToSlide (index: number, event: any) {
      this.currentIndex = index
      event.stopPropagation()
    }
  }
})
